module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-content"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('div', {
    staticClass: "card-contents"
  }, [_c('div', {
    staticClass: "flexcenter"
  }, [_c('div', {
    staticClass: "cover-image"
  }, [_c('img', {
    attrs: {
      "src": _vm.getContentsThumbnailPath(_vm.contentsDetail.contentid, _vm.showScreen),
      "alt": _vm.contentsDetail.content_name
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "detail-content"
  }, [_c('div', {
    staticClass: "flexbetween"
  }, [_c('div', {
    staticClass: "content-name font28",
    domProps: {
      "innerHTML": _vm._s(_vm.getContentName())
    }
  })]), _vm._v(" "), (!_vm.isAu(_vm.platformName)) ? _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "rate"
  }, [(_vm.contentsDetail.progress == 100) ? _c('span', [_vm._v("★")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "progress"
  }, [_c('p', [_vm._v("学習進捗状況")]), _vm._v(" "), _c('div', {
    staticClass: "flexbox"
  }, [_c('div', {
    staticClass: "progress-bar"
  }, [_c('div', {
    staticClass: "data",
    style: ({
      width: _vm.contentsDetail.progress + '%'
    })
  })]), _vm._v(" "), _c('div', {
    staticClass: "percentage font14"
  }, [_vm._v(_vm._s(_vm.contentsDetail.progress) + "%")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "content-button"
  }, [_c('button', {
    on: {
      "click": _vm.goContentsHome
    }
  }, [_vm._v("学習をはじめる")])])])])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-9df3eec0", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/.pnpm/vue-loader@12.2.2_babel-core@6.26.3_css-loader@0.28.11_lodash@4.17.21_underscore@1.13.7_4259f1e8ed219b259faa30ad7c9cf11c/~/vue-loader/lib/template-compiler?{"id":"data-v-9df3eec0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/.pnpm/vue-loader@12.2.2_babel-core@6.26.3_css-loader@0.28.11_lodash@4.17.21_underscore@1.13.7_4259f1e8ed219b259faa30ad7c9cf11c/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/purchased/PurchasedDetail.vue
// module id = 728
// module chunks = 1